import * as React from 'react';
import { useCallback, useRef } from 'react';

export interface IFormItemAccessibilityLabelProps {
  id: string;
  children?: React.ReactNode;
}

/**
 * Componente dedicato alla gestione dell'accessibilità per le label dei form
 * item in caso di RadioGroup, CheckboxGroup e Select.
 * In questi casi, infatti, la label non è associata all'input tramite
 * l'attributo `for` ma tramite l'attributo `aria-labelledby`.
 */
export function FormItemAccessibilityLabel(
  props: IFormItemAccessibilityLabelProps,
) {
  const itemRef = useRef<HTMLDivElement | null>(null);
  const onRef = useCallback(
    (ref: HTMLDivElement | null) => {
      if (!ref) return;

      itemRef.current = ref;
      const label = itemRef.current.closest?.('label');
      if (label) {
        label.id = props.id;
      }
    },
    [props.id],
  );

  return <span ref={onRef}>{props.children}</span>;
}
